import React from 'react'
import { Outlet } from 'react-router-dom'

function SuppliersLayout() {
    return (
        <>
            <Outlet />
        </>
    )
}

export default SuppliersLayout;
